import React, { useState, useEffect } from 'react';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
// import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
// import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
// import CustomImage from '../../../UIComponents/CustomImage';
// import CustomLink from '../../../UIComponents/CustomLink';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
// import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { store } from '../../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import DatePickerHandler from '../../../UIComponents/DatePickerHandler';
import TimePickerHandler from '../../../UIComponents/TimePickerHandler';
import DateTimePickerHandler from '../../../UIComponents/DateTimePickerHandler';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';

export default function Form({ is_edit, edit_id, Page = "", is_reschedule=false, setIsReschedule }) {
    const store_data = JSON.parse(store());
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [IsBTNClicked, setIsBTNClicked] = useState(false);

    // const InitialData = {
    //     exam_title: "", 
    //     exam_banner: "", 
    //     pre_question_time_in_sec: "", 
    //     exam_date: "", 
    //     exam_start_time: "", 
    //     exam_end_time: "", 
    //     result_publish_date: "",
    //     portal_start_datetime: "", 
    //     portal_end_datetime: "", 
    //     enroll_start_date: "", 
    //     enroll_start_time: "", 
    //     enroll_end_date: "", 
    //     enroll_end_time: "", 
    //     enrollment_fee: "", 
    //     exam_discussion_video_path: "", 
    //     reference_file: "", 
    //     exam_question_file: "", 
    //     video_path: "", 
    //     exam_details: ""
    // }

    // const [FormData, setFormData] = useState(InitialData);
    const [FormData, setFormData] = useState({pre_question_time_in_sec: 0});
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);


    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/exams/fetchSingle", filter);
        const ExamData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: ExamData["id"],
                exam_title: ExamData["exam_title"], 
                exam_banner: ExamData["exam_banner"], 
                pre_question_time_in_sec: ExamData["pre_question_time_in_sec"], 
                exam_date: ExamData["exam_date"], 
                exam_start_time: ExamData["exam_start_time"], 
                exam_end_time: ExamData["exam_end_time"], 
                result_publish_date: ExamData["result_publish_date"],
                portal_start_datetime: ExamData["portal_start_datetime"].split(".")[0].replace("T", " "),
                portal_end_datetime: ExamData["portal_end_datetime"].split(".")[0].replace("T", " "),
                enroll_start_date: ExamData["enroll_start_date"], 
                enroll_start_time: ExamData["enroll_start_time"], 
                enroll_end_date: ExamData["enroll_end_date"], 
                enroll_end_time: ExamData["enroll_end_time"], 
                enrollment_fee: ExamData["enrollment_fee"], 
                exam_discussion_video_path: ExamData["exam_discussion_video_path"],
                reference_file: ExamData["reference_file"], 
                // exam_question_file: ExamData["exam_question_file"],
                video_path: ExamData["video_path"], 
                exam_details: ExamData["exam_details"]
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("EXAM", "AdminExams", "CREATE");
                const editAllowed = await hasPermission("EXAM", "AdminExams", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        if (IsBTNClicked) return;
        // Add validation logic
        let errors = [];
        if (!FormData.exam_title) errors.push('Exam Title is required.');
        // if (!FormData.exam_date) errors.push('Exam Date is required.');
        // if (!FormData.exam_start_time) errors.push('Exam Start Time is required.');
        // if (!FormData.exam_end_time) errors.push('Exam End Time is required.');
        setError(errors);
        if (errors.length > 0) {
            toast.error('Please fix validation errors.');
            return;
        }
        const payload = { 
            org_id: store_data?.org_id, 
            user_unique_id: store_data?.user_unique_id, 
            // ...FormData, 
            id: FormData?.id, 
            exam_title: FormData?.exam_title, 
            exam_banner: FormData?.exam_banner, 
            pre_question_time_in_sec: FormData?.pre_question_time_in_sec, 
            exam_date: FormData?.exam_date ? FormData?.exam_date : new Date(),
            exam_start_time: FormData?.exam_start_time, 
            exam_end_time: FormData?.exam_end_time, 
            result_publish_date: FormData?.result_publish_date ? FormData?.result_publish_date : new Date(),
            // portal_start_datetime: FormData?.portal_start_datetime,
            // portal_end_datetime: FormData?.portal_end_datetime,
            enroll_start_date: FormData?.enroll_start_date ? FormData?.enroll_start_date : new Date(), 
            enroll_start_time: FormData?.enroll_start_time, 
            enroll_end_date: FormData?.enroll_end_date ? FormData?.enroll_end_date : new Date(), 
            enroll_end_time: FormData?.enroll_end_time, 
            enrollment_fee: FormData?.enrollment_fee, 
            reference_file: FormData?.reference_file, 
            // exam_question_file: FormData?.exam_question_file, 
            video_path: FormData?.video_path, 
            exam_discussion_video_path: FormData?.exam_discussion_video_path, 
            exam_details: FormData?.exam_details,
            portal_end_datetime: FormData?.portal_end_datetime ? FormData?.portal_end_datetime.split(".")[0].replace("T", " ") : new Date().toISOString().split(".")[0].replace("T", " "),
            portal_start_datetime: FormData?.portal_start_datetime ? FormData?.portal_start_datetime.split(".")[0].replace("T", " ") : new Date().toISOString().split(".")[0].replace("T", " "),
        }
        const response = await postAPI(is_edit ? "/exams/update" : "/exams/create", payload);
        if (response?.status) {
            setIsBTNClicked(false);
            toast.success('Great Job ! New Exam has been scheduled .');
            setTimeout(()=> {
                window.location.reload();
            }, 5000)
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Invalid Request. We cannot proceed with this request for now.');
        setLoading(false)
        }
        setLoading(false)
    }
    return (

        <>
            {Loading ? <Loader /> :
                (!isAdmin() && !canCreate && !canEdit) ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div className={`col-12 col-md-12 ${is_reschedule ? 'd-none' : ''}`}>
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="exam_title" Type="text" Label="Exam Title" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="enrollment_fee" Type="number" Label="Enrollment Fee" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                        <FileUploadHandler form_data={FormData} setFormData={setFormData} Name="exam_banner" Label="Exam Banner Image" />
                        </div>
                        <div className={`col-12 col-md-12 ${is_reschedule ? 'd-none' : ''}`}>
                            <TextareaHandler form_data={FormData} setFormData={setFormData} Name="exam_details" Type="text" Label="Exam Details" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="video_path" Type="text" Label="Youtube Video URL" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="exam_discussion_video_path" Type="text" Label="Exam Discussion Video URL" />
                        </div>
                        <div className={`col-12 col-md-12 ${is_reschedule ? 'd-none' : ''}`}>
                            <FileUploadHandler form_data={FormData} setFormData={setFormData} Name="reference_file" Label="Reference File" />
                        </div>
                        {/* <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <FileUploadHandler form_data={FormData} setFormData={setFormData} Name="exam_question_file" Label="Exam Question File" />
                        </div> */}
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <DatePickerHandler form_data={FormData} setFormData={setFormData} Name="enroll_start_date" Type="date" Label="Enrollment Start Date" />
                        </div>
                        <div className={`col-6 col-md-6 mb-1 ${is_reschedule ? 'd-none' : ''}`}>
                            <TimePickerHandler form_data={FormData} setFormData={setFormData} Name="enroll_start_time" Type="time" Label="Enrollment Start Time" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`}>
                            <DatePickerHandler form_data={FormData} setFormData={setFormData} Name="enroll_end_date" Type="date" Label="Enrollment End Date" />
                        </div>
                        <div className={`col-6 col-md-6 mb-1 ${is_reschedule ? 'd-none' : ''}`}>
                            <TimePickerHandler form_data={FormData} setFormData={setFormData} Name="enroll_end_time" Type="time" Label="Enrollment End Time" />
                        </div>
                        <div className={`col-6 col-md-6 mb-1 ${is_reschedule ? 'd-none' : ''}`}>
                            <DateTimePickerHandler form_data={FormData} setFormData={setFormData} Name="portal_start_datetime" Type="time" Label="Portal Start Time" />
                        </div>
                        <div className={`col-6 col-md-6 mb-1 ${is_reschedule ? 'd-none' : ''}`}>
                            <DateTimePickerHandler form_data={FormData} setFormData={setFormData} Name="portal_end_datetime" Type="time" Label="Portal End Time" />
                        </div>
                        <div className={`col-6 col-md-6`}>
                            <DatePickerHandler form_data={FormData} setFormData={setFormData} Name="exam_date" Type="date" Label="Exam Date" />
                        </div>
                        <div className={`col-6 col-md-6 ${is_reschedule ? 'd-none' : ''}`} style={{display: 'none'}}>
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="pre_question_time_in_sec" Type="text" Label="Per Question Time ( In Second )" />
                        </div>
                        <div className="col-6 col-md-6 mb-1">
                            <TimePickerHandler form_data={FormData} setFormData={setFormData} Name="exam_start_time" Type="time" Label="Exam Start Time" />
                        </div>
                        <div className="col-6 col-md-6 mb-1">
                            <TimePickerHandler form_data={FormData} setFormData={setFormData} Name="exam_end_time" Type="time" Label="Exam End Time" />
                        </div>
                        <div className="col-6 col-md-6">
                            <DatePickerHandler form_data={FormData} setFormData={setFormData} Name="result_publish_date" Type="date" Label="Result Publish Date" />
                        </div>
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
